/* L4 Produktseite: Sprungleiste (Scrollspy, aktiver Chip rollt waagerecht mit, Fokus nach Sprung) und „Mehr anzeigen“. Ohne Bibliothek. */
(function () {
  /* Chat-Knopf (Fassade bzw. Shopify Inbox) weicht aus, solange ein Kaufknopf im unteren Bildschirmband liegt */
  var buys = Array.prototype.slice.call(document.querySelectorAll('.product-form__controls-group--submit'));
  if (buys.length && 'IntersectionObserver' in window) {
    var hits = new Set();
    var band = function () { return Math.max(0, window.innerHeight - 96); };
    var mk = function () {
      return new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) hits.add(e.target); else hits.delete(e.target); });
        document.documentElement.classList.toggle('gw-chat-weg', hits.size > 0);
      }, { rootMargin: '-' + band() + 'px 0px 0px 0px' });
    };
    var bo = mk();
    buys.forEach(function (b) { bo.observe(b); });
    var brt;
    window.addEventListener('resize', function () { clearTimeout(brt); brt = setTimeout(function () { bo.disconnect(); hits.clear(); bo = mk(); buys.forEach(function (b) { bo.observe(b); }); }, 200); });
  }

  var root = document.querySelector('[data-gw-pdp]');
  if (!root) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* „Mehr anzeigen“ (hidden="until-found", beforematch öffnet beim Finden per Strg+F) */
  Array.prototype.slice.call(root.querySelectorAll('[data-gw-pdp-more]')).forEach(function (btn) {
    var rest = document.getElementById(btn.getAttribute('aria-controls'));
    if (!rest) return;
    var label = btn.querySelector('[data-gw-pdp-more-label]');
    var set = function (open) {
      if (open) rest.removeAttribute('hidden'); else rest.setAttribute('hidden', 'until-found');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more');
    };
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    rest.addEventListener('beforematch', function () { set(true); });
  });

  var nav = root.querySelector('[data-gw-jump]');
  if (!nav) return;
  var list = nav.querySelector('ul');
  var links = Array.prototype.slice.call(nav.querySelectorAll('[data-gw-jump-link]'));
  var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  var active = -1;
  var lock = 0;

  var setActive = function (i) {
    if (i === active || i < 0) return;
    active = i;
    links.forEach(function (a, j) { if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    var li = links[i].parentNode;
    var left = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
    if (list.scrollWidth > list.clientWidth) {
      try { list.scrollTo({ left: Math.max(0, left), behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = left; }
    }
  };

  var topOffset = function () {
    var cs = getComputedStyle(document.documentElement);
    var v = window.innerWidth >= 960 ? cs.getPropertyValue('--header-desktop-sticky-height') : cs.getPropertyValue('--height-header');
    return (parseFloat(v) || 0) + nav.offsetHeight;
  };

  /* Scrollspy: aktiv ist der letzte Abschnitt, dessen Oberkante die Linie unter Header + Leiste passiert hat */
  var compute = function () {
    if (Date.now() < lock) return;
    var line = topOffset() + 60;
    var idx = 0;
    for (var i = 0; i < secs.length; i++) {
      if (secs[i] && secs[i].getBoundingClientRect().top <= line) idx = i;
    }
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
      var last = secs[secs.length - 1];
      if (last && last.getBoundingClientRect().top < window.innerHeight) idx = secs.length - 1;
    }
    setActive(idx);
  };

  var io;
  var observe = function () {
    if (io) io.disconnect();
    root.style.setProperty('--gw-jump-h', nav.offsetHeight + 'px');
    if (!('IntersectionObserver' in window)) return;
    var off = Math.round(topOffset());
    io = new IntersectionObserver(compute, { rootMargin: '-' + off + 'px 0px -40% 0px', threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
    secs.forEach(function (s) { if (s) io.observe(s); });
  };
  observe();
  compute();

  /* Schatten, sobald die Leiste klebt */
  var sentinel = root.querySelector('[data-gw-jump-sentinel]');
  if (sentinel && 'IntersectionObserver' in window) {
    var so;
    var watch = function () {
      if (so) so.disconnect();
      var off = Math.round(topOffset() - nav.offsetHeight);
      so = new IntersectionObserver(function (e) { nav.classList.toggle('is-stuck', !e[0].isIntersecting && e[0].boundingClientRect.top < off + 1); }, { rootMargin: '-' + (off + 1) + 'px 0px 0px 0px' });
      so.observe(sentinel);
    };
    watch();
    window.addEventListener('resize', watch);
  }

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { observe(); compute(); }, 150); });
  /* Klick: normaler Anker (scroll-margin-top regelt den Versatz), danach Fokus auf die Überschrift, ohne neuen Verlaufseintrag */
  links.forEach(function (a, i) {
    a.addEventListener('click', function (e) {
      var sec = secs[i];
      if (!sec) return;
      e.preventDefault();
      setActive(i);
      /* Während des (weichen) Scrollens bleibt der geklickte Chip aktiv; Freigabe bei scrollend bzw. spätestens nach 2,5 s */
      lock = Date.now() + (reduced ? 300 : 2500);
      var release = function () { lock = Date.now() + 100; window.removeEventListener('scrollend', release); };
      if ('onscrollend' in window) window.addEventListener('scrollend', release);
      sec.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + sec.id);
      var h = sec.querySelector('[tabindex="-1"]') || sec;
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    });
  });
})();
